import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import TextField from "@mui/material/TextField";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import classnames from "classnames";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Popper } from "../../../../../Popper/index.js";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Link } from "../../../../../Link/index.js";
import { UsersList } from "./UsersList.js";
import { useStyles } from "./MentionComponent.styles.js";
const MentionComponent = ({ updateNode, initialValues = {
    name: '',
    id: '',
    logo: '',
    type: ''
}, disableLink, removeHandler })=>{
    const [editor] = useLexicalComposerContext();
    const { classes } = useStyles();
    const [inputValue, setInputValue] = useState(initialValues.name);
    const [selectedValue, setSelectedValue] = useState(initialValues);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isEditingFinished, setIsEditingFinished] = useState(false);
    const spanRef = useRef(null);
    const inputRef = useRef(null);
    const open = Boolean(anchorEl);
    useEffect(()=>{
        var _inputRef_current, _inputRef_current1;
        null == (_inputRef_current = inputRef.current) || _inputRef_current.click();
        null == (_inputRef_current1 = inputRef.current) || _inputRef_current1.focus();
    }, []);
    useEffect(()=>{
        if (spanRef.current && inputRef.current) {
            const width = spanRef.current.offsetWidth;
            inputRef.current.style.width = `${width}px`;
        }
    }, [
        inputValue
    ]);
    useEffect(()=>{
        if (inputValue && updateNode) editor.update(()=>{
            updateNode({
                name: inputValue,
                id: '',
                logo: '',
                type: ''
            });
        });
    }, [
        inputValue
    ]);
    useEffect(()=>{
        if (selectedValue.id && updateNode) editor.update(()=>{
            updateNode({
                name: selectedValue.name,
                id: selectedValue.id,
                logo: selectedValue.logo,
                type: selectedValue.type
            });
        });
    }, [
        selectedValue
    ]);
    const clearAnchorElHandler = useCallback(()=>{
        setAnchorEl(null);
        setIsEditingFinished(true);
    }, []);
    const handleChange = (e)=>{
        var _e_target;
        setInputValue(null == e ? void 0 : null == (_e_target = e.target) ? void 0 : _e_target.value);
        if (anchorEl) return;
        setAnchorEl(null == e ? void 0 : e.target);
    };
    const handleKeyDown = (e)=>{
        if ('Backspace' === e.key && !inputValue) editor.update(()=>{
            removeHandler();
        });
    };
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setAnchorEl(()=>e.currentTarget);
    };
    const handleSelectValue = (value)=>{
        setSelectedValue(value);
        setIsEditingFinished(false);
    };
    if (selectedValue.id) return /*#__PURE__*/ jsx(Link, {
        stroke: false,
        to: `/personal/${selectedValue.id}`,
        variant: "simple",
        children: /*#__PURE__*/ jsx(Typography, {
            variant: "body2",
            color: "original.brand.primary",
            component: "span",
            children: `@${selectedValue.name}`
        })
    });
    if (!selectedValue.id && disableLink) return /*#__PURE__*/ jsx(Typography, {
        variant: "body2",
        color: "text.light.primary",
        component: "span",
        children: `@${selectedValue.name}`
    });
    if (isEditingFinished && !selectedValue.id) return /*#__PURE__*/ jsx(Typography, {
        variant: "body2",
        color: "text.light.tertirary",
        component: "span",
        children: `@${inputValue}`
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx("span", {
                ref: spanRef,
                className: classnames([
                    classes.span,
                    classes.hidden
                ]),
                children: inputValue
            }),
            /*#__PURE__*/ jsx(TextField, {
                inputRef: inputRef,
                name: "mentionInput",
                variant: "standard",
                type: "text",
                autoComplete: "off",
                value: inputValue,
                onChange: handleChange,
                onKeyDown: handleKeyDown,
                onClick: handleClick,
                color: "primary",
                slotProps: {
                    input: {
                        startAdornment: /*#__PURE__*/ jsx(Typography, {
                            variant: "body2",
                            color: "original.brand.primary",
                            component: "span",
                            children: "@"
                        }),
                        className: classes.input
                    },
                    htmlInput: {
                        className: classes.input
                    }
                }
            }),
            /*#__PURE__*/ jsx(ClickAwayListener, {
                onClickAway: clearAnchorElHandler,
                children: /*#__PURE__*/ jsx(Popper, {
                    open: open,
                    anchorEl: anchorEl,
                    placement: "bottom-start",
                    className: classes.popper,
                    children: /*#__PURE__*/ jsx(Box, {
                        my: "4",
                        minWidth: "200",
                        minHeight: "100",
                        bgcolor: "bg.light.primary",
                        radius: "l",
                        overflow: "hidden",
                        className: classes.container,
                        children: /*#__PURE__*/ jsx(UsersList, {
                            inputValue: inputValue,
                            handleSelectValue: handleSelectValue
                        })
                    })
                })
            })
        ]
    });
};
export { MentionComponent };
